// Every tooltip row and the column header share this grid so icons, names,
// and compute all line up vertically. The name track is `minmax(0, 1fr)` (not
// bare `1fr`, whose implicit min-content floor would let a long nowrap name
// widen that row and shove the fixed compute column out of alignment with the
// other rows) — names clip with an ellipsis instead.
export const ROW_GRID_TEMPLATE = "12px minmax(0, 1fr) 74px"

export const ROW_TRANSITION = "background-color 120ms ease, opacity 120ms ease"

// Width of the inline compute bar at 100% (the largest compute shown). Kept
// short so it reads as a small accent to the right of the number, not a chart.
export const MAX_BAR_WIDTH = 28

// Hovered rows get a faint wash; the bold region summary row gets a slightly
// stronger one so it still stands out against its highlighted lab children.
export const getHighlightBackground = (
  highlighted: boolean,
  emphasized: boolean | undefined
): string => {
  if (!highlighted) return "transparent"
  return emphasized ? "rgba(0, 0, 0, 0.11)" : "rgba(0, 0, 0, 0.06)"
}
